/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { GuardHelper } from 'app/shared/guards/guard-helper';

import { LoggedInGuard } from 'app/shared/guards/loggedin.guard';
import { PublicPageGuard } from 'app/shared/guards/public-page.guard';
import { UserGuard } from 'app/shared/guards/user.guard';
import { UserPreloadGuard } from 'app/shared/guards/user-preload.guard';
import { FullAccessGuard } from 'app/shared/guards/full-access.guard';
import { NavigateConfirmationGuard } from 'app/shared/guards/navigate-confirmation.guard';

export const guards: any[] = [
  FullAccessGuard,
  GuardHelper,
  LoggedInGuard,
  NavigateConfirmationGuard,
  PublicPageGuard,
  UserGuard,
  UserPreloadGuard,
];

export * from 'app/shared/guards/guard-helper';

export * from 'app/shared/guards/loggedin.guard';
export * from 'app/shared/guards/public-page.guard';
export * from 'app/shared/guards/user.guard';
export * from 'app/shared/guards/user-preload.guard';
export * from 'app/shared/guards/full-access.guard';
export * from 'app/shared/guards/navigate-confirmation.guard';
